<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
    <el-row type="flex" class="row1">
      <div class="box1">
        <el-form-item prop="outline_image" class="courseImage" style="margin:0">
          <span class="required">*</span>
          <el-upload action="#" class="avatar-uploader courseImageUpload" :show-file-list="false"
                     :before-upload="beforeUpload">
            <img v-if="ruleForm.outline_image" :src="$imgUrl(ruleForm.outline_image)" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </div>
      <div class="box2">
        <el-form-item label="课程名称：" prop="outline_name">
          <el-input v-model="ruleForm.outline_name"></el-input>
        </el-form-item>
        <el-form-item label="发布单位：" prop="enterprise_name">
          <p>{{ ruleForm.enterprise_name }}</p>
          <!-- <el-input v-model="ruleForm.enterprise_name"></el-input> -->
        </el-form-item>
        <el-form-item label="创建时间：" prop="utime_str">
          <p>{{ ruleForm.utime_str }}</p>
          <!-- <el-date-picker v-model="ruleForm.utime_str" type="datetime" placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker> -->
        </el-form-item>
        <el-form-item label="线下授课：" style="margin-bottom: 0 !important">
          <el-date-picker v-model="formatObj.date1" type="daterange" range-separator="至" start-placeholder="开始日期"
                          end-placeholder="结束日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </div>
    </el-row>
    <el-row type="flex" class="row2">
      <div class="box1">
        <el-form-item label="AI总分：" prop="ai_score">
          <div class="flex">
            <el-input class="rate margin_right_10" type="number" min="0" max="100" step="10"
                      v-model.number="ruleForm.ai_score"></el-input>
            <el-rate :value="formatRate" allow-half text-color="#ff9900" @change="rateChange">
            </el-rate>
          </div>
        </el-form-item>
      </div>
      <div class="box2">
        <el-form-item label="授课讲师：" prop="instructor">
          <el-input v-model="ruleForm.instructor" style="width: 350px"></el-input>
        </el-form-item>
      </div>
    </el-row>
    <el-row type="flex" class="row2">
      <div class="box1">
        <el-form-item label="" prop="offline_type" label-width="24px">
          <el-checkbox v-model="ruleForm.offline_type">开通线下报名</el-checkbox>
        </el-form-item>
      </div>
      <div class="box2">
        <el-form-item label="线下价格：" prop="offline_price">
          <el-input-number-unit style="width: 350px"  size="large" v-model="ruleForm.offline_price" :min="0.00" :disabled="!ruleForm.offline_type"   :precision="2"></el-input-number-unit>

        </el-form-item>
      </div>
    </el-row>
    <el-form-item label="适用岗位：" prop="outline_hier_dicts">
      <div class="tag-container">
        <!-- 遍历已选岗位并显示标签 -->
        <el-tag v-for="(item, index) in ruleForm.outline_hier_dicts" :key="index" closable
                @close="removePosition(index)">
          {{ item.value }}
        </el-tag>
        <!-- 添加按钮 -->
        <el-button type="primary" icon="el-icon-plus" circle @click="openSelectPosition" size="small"
                   class="margin_left_10" v-if="ruleForm.outline_hier_dicts.length<5"></el-button>
      </div>

    </el-form-item>
    <el-form-item label="课程简介：" prop="outline_intro">
      <el-input type="textarea" placeholder="请输入课程简介..." v-model="ruleForm.outline_intro" maxlength="300"
                show-word-limit rows="4">
      </el-input>
    </el-form-item>
    <el-row type="flex" class="changeMargin">
      <el-col :span="12">
        <el-form-item label="联系人：" prop="contact_person">
          <el-input v-model="ruleForm.contact_person"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系电话：" prop="contact_phone">
          <el-input v-model="ruleForm.contact_phone"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="地  址：" prop="contact_address">
      <el-input v-model="ruleForm.contact_address"></el-input>
    </el-form-item>
    <el-dialog v-dialogDrag title="裁切课程照片" :visible.sync="cropperModel.val" width='1100px' top="200px" :modal="false"
               :modal-append-to-body="false" v-if="cropperModel.val">
      <v-vuecropper :cropperModel="cropperModel" :imgFile="file" :imgW="300" :imgH="185"
                    v-on:upload="uploadFn"></v-vuecropper>
    </el-dialog>
    <!-- 引入岗位选择弹窗 -->
    <select-position ref="selectPositionRef"
                     @ok="handlePositionSelect"></select-position>
  </el-form>
</template>

<script>
import vuecropper from "@/components/commonComponents/vueCropper.vue";
import selectPosition from "./selectPosition.vue";
import elInputNumberUnit from "@/components/commonComponents/el-input-number-unit";

export default {
  components: {
    "v-vuecropper": vuecropper,
    selectPosition,
    elInputNumberUnit
  },
  data() {
    return {
      cropperModel: {val: false},
      file: '',
      formatObj: {
        date1: [],
        date2: [],
        education: null
      },
      ruleForm: {
        utime_str: '',//创建时间
        outline_id: '',//	主课程详情 ID
        outline_name: '',//	课程名称
        enterprise_id: '',//	企业 ID
        enterprise_name: '',//	企业名称
        outline_image: '',//	课程图片 URL
        offline_start_date: '',//	线下授课开始日期
        offline_end_date: '',//	线下授课结束日期
        ai_score: null,//	int	AI 总分
        instructor: '',//	授课讲师
        outline_intro: '',//	课程简介
        contact_person: '',//	联系人
        contact_phone: '',//	联系电话
        contact_address: '',//	地址
        outline_hier_dicts: [],//	适用岗位
        offline_type: 'false',
        offline_price:''
      },
      customError: '',
      rules: {
        outline_image: [
          {required: true, message: '请上传课程图片',},

        ],
        outline_name: [
          {required: true, message: '请输入课程名称', trigger: 'blur'},

        ],
        utime_str: [
          {required: true, message: '请选择创建时间',}
        ],
        ai_score: [
          {required: true, message: '请填写或鼠标点击AI总分',}
        ],
        outline_hier_dicts: [
          {required: true, message: '请选择适用岗位',}
        ],

        outline_intro: [
          {required: true, message: '请填写课程简介',}
        ],
        date1: [
          {
            required: true, message: '请选择开始时间和结束时间'
          }
        ]

      }
    };
  },
  computed: {
    formatRate() {
      console.log(this.ruleForm.ai_score);
      return Number(this.ruleForm.ai_score) ? Number(this.ruleForm.ai_score) / 20 : 0
    }
  },
  methods: {

    getData(outline_id) {
      this.ruleForm.outline_id = outline_id
      this.$tools
          .asyncPost(
              this,
              this.$baseUrl.trainingCourseGet, {
                data: {
                  outline_id: outline_id
                }
              }).then((res) => {
        if (res.data.code == 0) {
          console.log(res.data.data);
          this.ruleForm = res.data.data
          this.ruleForm.offline_price =this.ruleForm.offline_price?.length>0? parseFloat(this.ruleForm.offline_price):0
          this.ruleForm.offline_type = this.ruleForm.offline_type == 'true'?true:false
          if (!this.ruleForm.outline_hier_dicts) {
            this.ruleForm.outline_hier_dicts = []
          }
          if (this.ruleForm.offline_start_date && this.ruleForm.offline_end_date) {
            this.formatObj.date1 = [this.ruleForm.offline_start_date, this.ruleForm.offline_end_date]
          } else {
            this.formatObj.date1 = []
          }


        } else {
          this.$message({type: "error", message: res.data.msg});
        }
        // this.loading = false;
      }).catch((err) => {
        // this.loading = false;
      });

    },
    // 评分改变
    rateChange(val) {
      this.ruleForm.ai_score = val * 20
    },
    // 上传前
    beforeUpload(file) {
      console.log(333);
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message({type: "error", message: "上传头像图片只能是 JPG 格式!"});
      }
      if (!isLt2M) {
        this.$message({type: "error", message: "上传头像图片大小不能超过 2MB!"});

      }
      if (isJPG && isLt2M) {
        this.cropperModel.val = true
        this.file = [{
          url: URL.createObjectURL(file),
        }];
      }
      return isJPG && isLt2M;
    },
    // positionSuccess(res, file) {
    //     this.cropperModel.val = true
    //     this.file = file;
    // },
    positionHeaderUpload(file) {
      this.form.banner_pic = file
      this.formdata6 = new FormData()
      var files = this.convertBase64ToFile(file, this.ruleForm.outline_id);
      this.formdata6.append('file', files, this.file[this.file.length - 1].name);
      this.formdata6.append('rename', '1');
    },
    convertBase64ToFile(base64String, fileName) {
      const byteCharacters = atob(base64String.substring(base64String.indexOf(',') + 1));
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {type: 'image/jpg'});
      const file = new File([blob], fileName, {type: blob.type});
      return file;
    },
    // 上传
    uploadFn(file) {


      let newFile = this.convertBase64ToFile(file, this.ruleForm.outline_id);
      var formdata = new FormData()
      formdata.append('file', newFile, this.ruleForm.outline_id + '.jpg');
      // formdata.append('filename',this.ruleForm.outline_id+'.jpg');
      formdata.append('rename', '0');
      //this.$baseUrl.filesupload + '/public/trainingCourse/' + localStorage.getItem('enterprise_id') + '/pic'
      //先测试使用
      this.$axios.post(this.$baseUrl.filesupload + '/public/' + localStorage.getItem('enterprise_id') + '/trainingCourse/pic', formdata,
          {
            headers: {
              'token': localStorage.getItem("token"),
              'content-type': 'multipart/form-data'
            }
          }
      ).then((res) => {
        if (res.data.code == 0) {
          this.ruleForm.outline_image = res.data.data[res.data.data.length - 1].upload_path;
          let obj = {
            ...this.ruleForm,

          }
          let formaterFileds = {
            offline_start_date: this.formatObj.date1.length ? this.formatObj.date1[0] : "",
            offline_end_date: this.formatObj.date1.length ? this.formatObj.date1[1] : "",
            offline_price:obj.offline_price>0?obj.offline_price?.toString():'0',
            offline_type:obj.offline_type == true?'true':'false'
          }
          // 先保存到数据库
          this.$tools
              .asyncPost(
                  this,
                  this.$baseUrl.trainingCourseEdit, {
                    data: Object.assign(obj, formaterFileds)
                  }).then((res) => {
            if (res.data.code == 0) {
              this.$message({type: "success", message: '头像保存成功'});
              // this.$emit('ok')
              this.dialogVisible = false


            } else {
              this.$message({type: "error", message: res.data.msg});
            }
          }).catch((err) => {
            this.loading = false;
          });
          this.$forceUpdate()
        } else {
          this.$message({type: "error", message: res.data.msg})
        }

      })

    },
    // 2、非表单校验
    checkCustomValid() {
      if (!this.formatObj.date1.length) {
        this.customError = '请选择开始时间和结束时间'
        return false
      } else {
        this.customError = ''
        return true
      }
    },

    handleOk() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let obj = {
            ...this.ruleForm,

          }
          let formaterFileds = {
            offline_start_date: this.formatObj.date1.length ? this.formatObj.date1[0] : "",
            offline_end_date: this.formatObj.date1.length ? this.formatObj.date1[1] : "",
            offline_price:obj.offline_price>0?obj.offline_price?.toString():'0',
            offline_type:obj.offline_type == true?'true':'false'
          }
          this.$tools
              .asyncPost(
                  this,
                  this.$baseUrl.trainingCourseEdit, {
                    data: Object.assign(obj, formaterFileds)
                  }).then((res) => {
            if (res.data.code == 0) {
              this.$message({type: "success", message: '保存成功'});
              this.$emit('ok')
              this.dialogVisible = false


            } else {
              this.$message({type: "error", message: res.data.msg});
            }
          }).catch((err) => {
            this.loading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 修改打开弹窗方法，通过ref调用子组件init方法
    openSelectPosition() {
      // 通过ref获取子组件实例并调用init方法
      this.$refs.selectPositionRef.init();
      // 显示弹窗
    },
    // 处理选择的岗位
    handlePositionSelect(position) {
      // 检查是否已存在相同岗位，避免重复添加
      const isDuplicate = this.ruleForm.outline_hier_dicts.some(
          item => item.key === position.key
      );

      if (!isDuplicate) {
        this.ruleForm.outline_hier_dicts.push(position);
      } else {
        this.$message({type: "warning", message: '该岗位已添加'});

      }
    },

    // 删除岗位标签
    removePosition(index) {
      this.ruleForm.outline_hier_dicts.splice(index, 1);
    },


  }
}
</script>

<style lang="less" scoped>
.demo-ruleForm {
  width: 100%;
  padding-right: 10px;

  .box1 {
    width: 280px;
    margin-right: 10px;

  }

  .row1 {
    align-items: center;
  }

  /deep/ .el-form-item {
    margin: 10px 0 !important;
  }

  .row2 {
    .box2 {

      .el-form-item:nth-child(1) {
        // margin-top: 10px;
      }

      /deep/ .el-form-item:nth-child(4) {
        margin-bottom: 0;
      }

    }
  }


  .courseImage {
    // height: 100%;

    .required {
      width: 25px;
      content: '*';
      color: #F56C6C;
      text-align: right;
      margin-right: 4px;
    }

    /deep/ .el-form-item__content {
      display: flex;
      margin-left: 0 !important;

      .courseImageUpload {
        height: 161px;
        // flex: 1;
        // min-width: 0;
        width: 226px;

        .el-upload.el-upload--text {
          width: 100%;
          height: calc(100% - 0px);
        }

        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 100%;
          // height: 100%;
          line-height: 161px;
          text-align: center;
        }

        img {
          height: 100%;
          width: 100%;

          object-fit: cover;
        }
      }
    }
  }
}

// 
.flex {
  display: flex;
  align-items: center;
}

.rate {
  width: 50px;

  /deep/ .el-input__inner {
    padding: 0 0 0 5px;
  }

  //

}
</style>